<script>
export default {
  name: "payment-badge",
}
</script>

<template>
  <b-badge class="payment-badge" v-bind="$attrs">
    <slot>Payment Status</slot>
  </b-badge>
</template>

<style lang="scss" scoped>
.payment-badge {
  border-radius: 4px;
  font: 400 12px Lato;
  padding: 2px;
  background-color: black;
  color: white;
}

.paid {
  background-color: #DCFCE7;
  color: #15803D;
}

.unpaid {
  background-color: #FEE2E2;
  color: #EF4444;
}
</style>